var _excluded = ["value", "locale", "timezone"];
import React from "react";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { formatDate } from '@prezly/theme-kit-intl';
import { toDate } from "./utils.mjs";
export function BaseFormattedDate(_ref) {
  var {
      value,
      locale,
      timezone
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  var dateTime = toDate(value);
  return /*#__PURE__*/React.createElement("time", _extends({}, attributes, {
    dateTime: dateTime.toISOString()
  }), formatDate(dateTime, {
    locale,
    timezone
  }));
}